import { render, staticRenderFns } from "./ed-tabs-header.vue?vue&type=template&id=3f7f95ac&scoped=true&"
import script from "./ed-tabs-header.ts?vue&type=script&lang=ts&"
export * from "./ed-tabs-header.ts?vue&type=script&lang=ts&"
import style0 from "./ed-tabs-header.scss?vue&type=style&index=0&id=3f7f95ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7f95ac",
  null
  
)

export default component.exports